import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';
import { miniCardHeight, miniCardWidth } from '../../../modules/utils/constants/constants';

export const StyledOutletMiniCard = styled.div`
  width: ${toRem(miniCardWidth)};
  min-width: ${toRem(miniCardWidth)};
  height: ${toRem(miniCardHeight)};
  background-color: ${baseVariables.color.base20};
  box-shadow: rgba(0, 0, 0, 0.25) 0px ${toRem(7)} ${toRem(20)} 0px;

  .minicard {
    &__image {
      width: ${toRem(112)};
      min-width: ${toRem(112)};
      height: ${toRem(miniCardHeight)};
      min-height: ${toRem(miniCardHeight)};
    }

    &__details {
      width: 100%;
    }

    &__property-name {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-wrap: wrap;
      border-top: 1px solid rgba(238, 238, 238, 1);
    }
  }
`;
